import { createTheme } from '@mui/material/styles';
import { esES } from '@mui/material/locale';
import { palette } from './palette';

const theme = createTheme({
    palette,
  }, esES);

  export default theme;